import { UserAuditLogEntry } from 'apis/auditLogs';

import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type DeliveryAttemptFailedProps = {
  entry: UserAuditLogEntry<'COMMERCE_DELIVERY_ATTEMPT_FAILED'>;
};

export const DeliveryAttemptFailed = ({
  entry,
}: DeliveryAttemptFailedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="exclamation-triangle-filled"
    color={statusColors.negative}
    title="Delivery attempt failed"
    summary={
      <SummaryItems
        items={[
          { key: 'order', content: entry.order_id, copyText: entry.order_id },
          {
            key: 'fulfillment',
            content: entry.fulfillment_id,
            copyText: entry.fulfillment_id,
          },
          { key: 'reason', content: entry.reason },
        ]}
      />
    }
  />
);
